import React from 'react';
import { CtaBlock } from '../CtaButton';
import { Accent } from './SectionHeading';
import { MOCKUP_URL } from '../../data/images';

/** Section 13 — the price reveal and the checkout button. */
export function CheckoutSection() {
  return <section id="offer" aria-labelledby="offer-heading" className="bg-brand-lavender px-5 py-16 lg:px-8 lg:py-24" data-id="element-57" data-mp="1ts9vlmyg8nh6">
      <div className="mx-auto max-w-3xl overflow-hidden rounded-[28px] border-2 border-brand-plum/25 bg-white shadow-[0_50px_100px_-50px_rgba(59,27,87,0.55)]" data-id="element-58" data-mp="1oqkhtzjudvpe">
        <div className="bg-brand-plum-dark px-6 py-4 text-center" data-id="element-59" data-mp="2hicf3eoasl46">
          <p className="font-body text-[12px] font-bold uppercase tracking-[0.2em] text-white" data-id="element-60" data-mp="2chy9e3a65n9b">
            6 Core Volumes + 5 Extra Bonuses
          </p>
        </div>

        <div className="px-6 py-12 text-center sm:px-12" data-id="element-61" data-mp="28ipeuw7b1lcp">
          <p className="font-body text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-plum" data-id="element-62" data-mp="11444migsy28w">
            Building these resources yourself could take weeks.
          </p>
          <h2 id="offer-heading" className="mx-auto mt-4 font-display text-[2.4rem] font-bold leading-[1.04] text-brand-charcoal sm:text-[3.1rem]" data-id="element-63" data-mp="30i8fkashlohq">
            Get the Complete <Accent data-id="element-64" data-mp="2rilddmrxoenm">System Today.</Accent>
          </h2>

          <img src={MOCKUP_URL} alt="Makeup Instructor Ready — 6 core volumes and 5 extra bonuses" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto mt-8 block w-full rounded-[16px]" data-id="element-65" data-mp="2rk67jbac5vky" />

          <p className="mt-10 font-body font-bold leading-none tracking-[-0.01em] text-brand-charcoal" data-id="element-66" data-mp="27tugrstkqo54">
            <span className="text-[4rem] sm:text-[4.75rem]" data-id="element-67" data-mp="2csxd8ovhnm1h">$27</span>
            <span className="ml-2 text-[1.25rem] text-brand-charcoal/60" data-id="element-68" data-mp="2ct72294srn5l">USD</span>
          </p>
          <p className="mt-3 font-body text-[12px] font-semibold uppercase tracking-[0.2em] text-brand-plum" data-id="element-69" data-mp="1ytxx65m1kfgx">
            One-Time Payment
          </p>

          <div id="offer-cta" className="scroll-mt-24" data-id="element-70" data-mp="9ck68kt6m53k">
            <CtaBlock label="Get Instant Access for $27" action="checkout" note="No Subscription • Digital Product • Access After Purchase" className="mt-8" data-id="element-71" data-mp="9e3r6ops94bo" />
          </div>
        </div>
      </div>
    </section>;
}